export interface Lesson {
  id: string;
  lessonNumber: number;
  title: string;
  vimeoEmbedUrl?: string;
}

export interface CourseModule {
  id: string;
  moduleNumber: number;
  title: string;
  lessons: Lesson[];
}

function vimeoEmbed(vimeoId: string, hash: string): string {
  return `https://player.vimeo.com/video/${vimeoId}?h=${hash}`;
}

export const courseModules: CourseModule[] = [
  {
    id: 'module-1',
    moduleNumber: 1,
    title: 'Introduction to Real Estate Investing',
    lessons: [
      { id: 'm1-l1', lessonNumber: 1, title: 'A Tale of Two Farmers', vimeoEmbedUrl: vimeoEmbed('1168054344', '052acf40f2') },
      { id: 'm1-l2', lessonNumber: 2, title: 'About This Course', vimeoEmbedUrl: vimeoEmbed('1168057039', 'fd2516e426') },
      { id: 'm1-l3', lessonNumber: 3, title: 'Why Rental Properties?', vimeoEmbedUrl: vimeoEmbed('1168058529', 'e6a7113c41') },
      { id: 'm1-l4', lessonNumber: 4, title: '11 Reasons to Run from Real Estate', vimeoEmbedUrl: vimeoEmbed('1168061132', 'e20bb8a170') },
    ],
  },
  {
    id: 'module-2',
    moduleNumber: 2,
    title: 'Turning Ambiguity into Clarity',
    lessons: [
      { id: 'm2-l1', lessonNumber: 1, title: 'Intro to Crystal Clear Criteria', vimeoEmbedUrl: vimeoEmbed('1168064574', 'b15f7b14ca') },
      { id: 'm2-l2', lessonNumber: 2, title: 'Niche', vimeoEmbedUrl: vimeoEmbed('1168064991', 'e2b710c9d9') },
      { id: 'm2-l3', lessonNumber: 3, title: 'Strategy', vimeoEmbedUrl: vimeoEmbed('1168065700', 'c4751252ee') },
      { id: 'm2-l4', lessonNumber: 4, title: 'Location', vimeoEmbedUrl: vimeoEmbed('1168066600', '039dec2eee') },
      { id: 'm2-l5', lessonNumber: 5, title: 'Long-Distance vs Local', vimeoEmbedUrl: vimeoEmbed('1168067193', '372777c4c0') },
      { id: 'm2-l6', lessonNumber: 6, title: 'Which Comes First', vimeoEmbedUrl: vimeoEmbed('1168067794', '3bac19ff8f') },
      { id: 'm2-l7', lessonNumber: 7, title: 'Price Range', vimeoEmbedUrl: vimeoEmbed('1168068207', '467e028920') },
      { id: 'm2-l8', lessonNumber: 8, title: 'Property Condition', vimeoEmbedUrl: vimeoEmbed('1168068489', 'f9f4eab21d') },
      { id: 'm2-l9', lessonNumber: 9, title: 'Property Profitability', vimeoEmbedUrl: vimeoEmbed('1168068871', 'dd64534e5b') },
    ],
  },
  {
    id: 'module-3',
    moduleNumber: 3,
    title: 'Your Financial Freedom Vision',
    lessons: [
      { id: 'm3-l1', lessonNumber: 1, title: 'Planning Is Everything', vimeoEmbedUrl: vimeoEmbed('1168084270', '03c7786fd9') },
      { id: 'm3-l2', lessonNumber: 2, title: 'Five Sample Paths to Financial Freedom', vimeoEmbedUrl: vimeoEmbed('1168085510', '2b428870b2') },
      { id: 'm3-l3', lessonNumber: 3, title: 'Your Financial Freedom Vision', vimeoEmbedUrl: vimeoEmbed('1168088406', 'ce3fe02cb1') },
    ],
  },
  {
    id: 'module-4',
    moduleNumber: 4,
    title: 'Finding Deals and Opportunities',
    lessons: [
      { id: 'm4-l1', lessonNumber: 1, title: 'The LUCK Method Introduced', vimeoEmbedUrl: vimeoEmbed('1168088624', '08b60b027b') },
      { id: 'm4-l2', lessonNumber: 2, title: 'On Market Deals', vimeoEmbedUrl: vimeoEmbed('1168089475', 'ca9541d4fc') },
      { id: 'm4-l3', lessonNumber: 3, title: 'Finding a Rock Star Real Estate Agent', vimeoEmbedUrl: vimeoEmbed('1168090251', '2c67e288d3') },
      { id: 'm4-l4', lessonNumber: 4, title: 'How to Find Great Deals on the Competitive MLS', vimeoEmbedUrl: vimeoEmbed('1168090883', '162b3c6e20') },
      { id: 'm4-l5', lessonNumber: 5, title: 'Lesson 4.5', vimeoEmbedUrl: vimeoEmbed('1168091378', '0a16433df8') },
    ],
  },
  {
    id: 'module-5',
    moduleNumber: 5,
    title: 'Finding Off-Market Deals',
    lessons: [
      { id: 'm5-l1', lessonNumber: 1, title: 'Off Market Deal Finding', vimeoEmbedUrl: vimeoEmbed('1168106269', 'c5e9f7920a') },
      { id: 'm5-l2', lessonNumber: 2, title: 'How to Pull a List to Find Deals', vimeoEmbedUrl: vimeoEmbed('1168107111', '1e555ea225') },
    ],
  },
  {
    id: 'module-6',
    moduleNumber: 6,
    title: 'Underwriting Deals',
    lessons: [
      { id: 'm6-l1', lessonNumber: 1, title: 'Introduction to Deal Underwriting (Analysis)', vimeoEmbedUrl: vimeoEmbed('1168107169', 'b7a0427382') },
      { id: 'm6-l2', lessonNumber: 2, title: 'The Four Square Method', vimeoEmbedUrl: vimeoEmbed('1168108235', '42c969fb49') },
      { id: 'm6-l3', lessonNumber: 3, title: 'Ultimate Guide to Cash Flowing Rental Properties (Part 1)', vimeoEmbedUrl: vimeoEmbed('1168108817', 'c2657127f9') },
      { id: 'm6-l4', lessonNumber: 4, title: 'Ultimate Guide to Cash Flowing Rental Properties (Part 2)', vimeoEmbedUrl: vimeoEmbed('1168109700', '443a6cf033') },
      { id: 'm6-l5', lessonNumber: 5, title: 'Lesson 6.5', vimeoEmbedUrl: vimeoEmbed('1168110363', '73e2190409') },
      { id: 'm6-l6', lessonNumber: 6, title: 'Lesson 6.6', vimeoEmbedUrl: vimeoEmbed('1168110803', '2ac7c7030c') },
      { id: 'm6-l7', lessonNumber: 7, title: 'Lesson 6.7', vimeoEmbedUrl: vimeoEmbed('1168111354', '1109ed400c') },
      { id: 'm6-l8', lessonNumber: 8, title: 'Lesson 6.8', vimeoEmbedUrl: vimeoEmbed('1168112083', '8271d4a631') },
    ],
  },
  {
    id: 'module-7',
    moduleNumber: 7,
    title: 'Rental Property Financing',
    lessons: [
      { id: 'm7-l1', lessonNumber: 1, title: 'Intro to Rental Property Financing', vimeoEmbedUrl: vimeoEmbed('1168112669', '51f4767832') },
      { id: 'm7-l2', lessonNumber: 2, title: 'The Secret to Unlocking Unlimited Bank Lending', vimeoEmbedUrl: vimeoEmbed('1168113212', '48f3eae43e') },
      { id: 'm7-l3', lessonNumber: 3, title: 'Hard Money Loans', vimeoEmbedUrl: vimeoEmbed('1168114096', 'ac01caa829') },
      { id: 'm7-l4', lessonNumber: 4, title: 'The BRRRR Strategy', vimeoEmbedUrl: vimeoEmbed('1168114558', 'fa40a12407') },
    ],
  },
  {
    id: 'module-8',
    moduleNumber: 8,
    title: 'Offers and Negotiation',
    lessons: [
      { id: 'm8-l1', lessonNumber: 1, title: 'An Introduction to Offering and Negotiating Your Deal', vimeoEmbedUrl: vimeoEmbed('1168118308', '92d868d23c') },
      { id: 'm8-l2', lessonNumber: 2, title: 'Making Your Offer', vimeoEmbedUrl: vimeoEmbed('1168119491', '9ea566323f') },
      { id: 'm8-l3', lessonNumber: 3, title: 'Tips for Getting Your Offer Accepted', vimeoEmbedUrl: vimeoEmbed('1168120087', '90b66d8818') },
      { id: 'm8-l4', lessonNumber: 4, title: 'The Art of Negotiation', vimeoEmbedUrl: vimeoEmbed('1168120559', '0ebbaa37c9') },
      { id: 'm8-l5', lessonNumber: 5, title: 'Lesson 8.5', vimeoEmbedUrl: vimeoEmbed('1168120964', 'dfd49cc42e') },
      { id: 'm8-l6', lessonNumber: 6, title: 'Lesson 8.6', vimeoEmbedUrl: vimeoEmbed('1168121157', '50fc21ebda') },
    ],
  },
  {
    id: 'module-9',
    moduleNumber: 9,
    title: 'Due Diligence',
    lessons: [
      { id: 'm9-l1', lessonNumber: 1, title: 'What Is Due Diligence?', vimeoEmbedUrl: vimeoEmbed('1168121550', 'df570178b1') },
      { id: 'm9-l2', lessonNumber: 2, title: 'Property Inspections', vimeoEmbedUrl: vimeoEmbed('1168121766', 'e4ca5a673a') },
      { id: 'm9-l3', lessonNumber: 3, title: 'Insurance', vimeoEmbedUrl: vimeoEmbed('1168122170', 'c4c561a9ce') },
      { id: 'm9-l4', lessonNumber: 4, title: 'Tenants, Leases, and Other Contracts', vimeoEmbedUrl: vimeoEmbed('1168122703', '7d9c082324') },
      { id: 'm9-l5', lessonNumber: 5, title: 'Zoning Considerations', vimeoEmbedUrl: vimeoEmbed('1168123325', '38b2bb2871') },
      { id: 'm9-l6', lessonNumber: 6, title: 'Reviewing Documents' },
    ],
  },
  {
    id: 'module-10',
    moduleNumber: 10,
    title: 'Managing a Rental Property',
    lessons: [
      { id: 'm10-l1', lessonNumber: 1, title: 'Introduction to Managing Rentals', vimeoEmbedUrl: vimeoEmbed('1168124087', '72b17f42a9') },
      { id: 'm10-l2', lessonNumber: 2, title: 'Should You Hire a Property Manager?', vimeoEmbedUrl: vimeoEmbed('1168124219', '0cb0e4599c') },
      { id: 'm10-l3', lessonNumber: 3, title: 'How to Find a Great Property Manager' },
      { id: 'm10-l4', lessonNumber: 4, title: 'Tips for Being a Profitable and Stress Free Landlord' },
      { id: 'm10-l5', lessonNumber: 5, title: 'Dealing with Problems as a Landlord' },
    ],
  },
  {
    id: 'module-11',
    moduleNumber: 11,
    title: 'The Legal and Tax Side of Rental Properties',
    lessons: [
      { id: 'm11-l1', lessonNumber: 1, title: 'Your Guide to LLCs, Bookkeeping, Taxes, and Tax-Saving Strategies' },
      { id: 'm11-l2', lessonNumber: 2, title: 'LLCs, Corporations, and Other Legal Entities' },
      { id: 'm11-l3', lessonNumber: 3, title: 'Effective Bookkeeping' },
    ],
  },
  {
    id: 'module-12',
    moduleNumber: 12,
    title: 'Closing',
    lessons: [
      { id: 'm12-l1', lessonNumber: 1, title: 'How The Rich Pay No Income Tax' },
      { id: 'm12-l2', lessonNumber: 2, title: 'Closing' },
    ],
  },
];

export const taxCourseModules: CourseModule[] = [
  {
    id: 'tax-module-1',
    moduleNumber: 1,
    title: 'Real Estate Tax Savings Blueprint',
    lessons: [
      { id: 'tax-l1', lessonNumber: 1, title: 'The Wealth Secret of the Wealthy' },
      { id: 'tax-l2', lessonNumber: 2, title: 'The 3 Core Ways Real Estate Lowers Taxes' },
      { id: 'tax-l3', lessonNumber: 3, title: 'Using Entities for Optimal Tax Efficiency' },
      { id: 'tax-l4', lessonNumber: 4, title: '5 Ways to Use Real Estate to Offset W-2 and Business Income' },
      { id: 'tax-l5', lessonNumber: 5, title: 'The Strategy Ladder' },
      { id: 'tax-l6', lessonNumber: 6, title: 'Keep More. Build More.' },
    ],
  },
];

export const totalTaxLessons = taxCourseModules.reduce((sum, m) => sum + m.lessons.length, 0);

export const totalLessons = courseModules.reduce((sum, m) => sum + m.lessons.length, 0);
